<template>
  <div class="bookDetail">
    <div class="content">
      <img class="img" :src='book.image'>
      <p class="name">{{book.title}}</p>
      <p class="des">{{book.recommendWord}}</p>
      <div class="underLine"></div>
      <p class="txt">送你一本好书，感谢有你！</p>
      <div class="signBox">
        <p class="line"></p>
        <p class="txt sign">{{book.userName}}</p>
      </div>
    </div>
    <div v-if='!getBook' @click='handleGetBook' class="button">领取赠书（音频解读版）</div>
    <div v-else class="button">已领取 - 去获得更多赠书</div>
    <div v-if="requestFinished" class="explain">{{statusText}}</div>
    <Modal 
      v-if="modal"
      :modalType='type'
      :des='des'
      @close='handleClose'
      @download='handleDownload'
    />
  </div>
</template>

<script>
import login from '@/utils/login'
import os from '@edu-fe/os'
import api from '../../../lib/api/index'
import Modal from '../Modal'
export default {
  data () {
    return {
      getBook: false,
      modal: false,
      book: {},
      type: 1,
      des: '',
      requestFinished: false
    }
  },
  computed: {
    statusText() {
      return this.getBook ?
        `你已通过本期才博图书馆获得本书，打开才博APP赠送书籍给朋友领取，一起获得更多赠书` :
        `最多可通过本期“才博图书馆 - 赠一得一”免费领取1本，你免费领取后，${ this.book.userName }也将免费获得本书`
    }
  },
  mounted() {
    login.login()
    this.shareBook()
  },
  methods: {
    handleDownload() {
      this.$router.push('download-app')
    },
    handleClose() {
      this.modal = false
    },
    async shareBook () {
      // 获取课程id 分享者ids
      const shareId = this.$route.query.shareId
      const { data = {} } = await api.present.shareBook(shareId)()
      this.requestFinished = true
      this.book = data
      this.getBook = data.isReceive
    },
    async getBookData() {
      const shareId = this.$route.query.shareId
      const data = await api.present.getBook(shareId)()
      if(data.data === 1){ // 成功
        this.type = 1
      }else if(data.data === 2) { //失败
        this.type = 3
        this.des =  '您已经领取过'
      }else if(data.data === 3) { //失败
        this.type = 3
        this.des =  '已经被他人助力'
      }else if(data.data === 4) { //失败
        this.type = 3
        this.des =  '很抱歉，本活动已结束!'
      }else if(data.data === 5) { //失败
        this.type = 3
        this.des =  '这期您已经助力过了!'
      }else if(data.data === 6) { //失败
        this.type = 3
        this.des =  '用户本人不能助力!'
      }
      this.modal = true
    },
    handleGetBook() {
      this.getBookData()
    },
  },
  components: {
    Modal
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../../style/main";

.bookDetail {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(249,249,249,0.84);
  display: flex;
  align-items: center;
  flex-direction: column;
  .content {
    width: rem(456);
    height: rem(690);
    padding: 0 rem(60) rem(41) rem(60);
    background: #fff;
    margin-top: rem(208);
    box-shadow:rem(0) rem(10) rem(38) rem(0) rgba(240,240,240,1);
    border-radius: rem(10);
    display: flex;
    flex-direction: column;
    align-items: center;
    .img {
      width: rem(309);
      height: rem(380);
      border-radius: rem(10);
      background: #ccc;
      margin-top: rem(-49);
    }
    .name {
      height:rem(45);
      font-size:rem(32);
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(51,51,51,1);
      line-height:rem(45);
      margin-top: rem(49);
    }
    .des {
      width: rem(456);
      font-size:rem(24);
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(153,153,153,1);
      line-height:rem(33);
      text-align: center;
      margin-top: rem(10);
    }
    .underLine {
      width: rem(520);
      height: rem(1);
      background: #E1E1E1;
      margin-top: rem(37);
    }
    .txt {
      font-size:rem(30);
      font-family:HYd4gj;
      color:rgba(102,102,102,1);
      line-height:rem(30);
      margin-top: rem(43);
    }
    .signBox {
      width: 100%;
      height: rem(30);
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: rem(18);
      .line {
        width: rem(92);
        height: rem(2);
        background: #666666;
        margin-top: rem(48);
        margin-right: rem(25);
      }
    }
  }
  .button {
    width:rem(572);
    height:rem(100);
    background:linear-gradient(270deg,rgba(254,140,67,1) 0%,rgba(255,114,83,1) 100%);
    border-radius:rem(10);
    margin-top: rem(40);
    line-height: rem(100);
    text-align: center;
    font-size:rem(36);
    font-family:PingFangSC-Semibold;
    font-weight:600;
    color: #fff;
  }
  .explain {
    width:rem(549);
    height:rem(70);
    font-size:rem(24);
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:rem(35);
    margin-top: rem(24);
    text-align: center;
  }
}
</style>
